import { Component, OnInit } from '@angular/core';
import { ReCaptchaV3Service } from "ng-recaptcha";
import { ActivatedRoute, Router } from '@angular/router';

// SERVICES
import { ApiService } from "src/app/Services/api.service";
import { UtilsService } from 'src/app/Services/utils.service';

type Complaint = {
  type: string,
  identifier: string,
  status: string,
  name: string,
  email: string,
  phone: string,
  createdAt: Date,
  municipality: string,
  line: string,
  stop: string,
  operator: string,
  place: string,
  occurrence_date: string,
  time: string,
  subsubject: string,
  message: string,
  closedAt: Date,
  notes: string
};


@Component({

  selector: 'app-reclamacao-detalhe',
  templateUrl: './reclamacao-detalhe.component.html',
  standalone: false
})
export class ReclamacaoDetalheComponent implements OnInit {
  title = 'cim-tamega-sousa';

  private complaintId: string = '';
  private token: string = '';

  public infoLoaded = 0;
  public complaint = {} as Complaint;
  public lineOperatorLogos: any[] = [];
  public hasError: boolean = false;

  constructor(
    private recaptchaV3Service: ReCaptchaV3Service,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private utilsService: UtilsService,
  ) {}

  ngOnInit(){
    this.activatedRoute.queryParams
    .subscribe(queryParams => {
      queryParams['id'] != undefined ? this.complaintId = queryParams['id'] : this.goHome();
    })

    this.recaptchaV3Service.execute('importantAction')
      .subscribe((token: string) => {
        this.token = token;
        if (this.complaintId != '') this.getComplaintDetail(this.complaintId)
      });
  }

  getComplaintDetail(id: string){
    this.infoLoaded = 0;
    this.hasError = false;
    this.apiService.getComplaint(id, this.token)
    .subscribe({
      next: data => {

        let response = data['body']

         if(response['type'] == 'RESERVATION'){
          this.router.navigate(['/reservas-detalhe'], { queryParams: { id: id } })
        }

        this.complaint.identifier = response['identifier']
        this.complaint.status = response['status']
        this.complaint.name = response['requested_by_name']
        this.complaint.email = this.utilsService.maskEmail(response['requested_by_email'])
        this.complaint.phone = this.utilsService.maskPhoneNumber(response['extra']['phone'])
        this.complaint.createdAt = response['created_at']
        this.complaint.municipality = response['extra']['municipality']
        this.complaint.line = response['extra']['line'] != ' - ' ? response['extra']['line'] : ''
        this.complaint.stop = response['extra']['stop']
        this.complaint.place = response['extra']['place']
        this.complaint.occurrence_date = response['occurrence_date']
        this.complaint.time = response['extra']['time']
        this.complaint.type = response['type']
        this.complaint.subsubject = response['subject']
        this.complaint.message = response['body']
        this.complaint.closedAt = response['closed_at']
        this.complaint.notes = response['notes']

        let op = response['ref'].split('##')[0]

        if (op != ''){
          switch (true) {
            case op == 'TRD':
              this.complaint.operator = 'Transdev Tâmega e Sousa, Mobilidade e Transporte Público, Unipessoal, Lda.';
              this.lineOperatorLogos.push('transdev');
              break;
            case op == 'EXP':
              this.complaint.operator = 'Expressdiagram - Transportes Rodoviários Lda.';
              this.lineOperatorLogos.push('valpi');
              this.lineOperatorLogos.push('rodonorte');
              break;
            case op == 'ETR':
              this.complaint.operator = 'Etapas Remotas - Transportes Rodoviários Lda.';
              this.lineOperatorLogos.push('valpi');
              this.lineOperatorLogos.push('rodonorte');
              break;
            case op == 'RDR':
              this.complaint.operator = 'Rota da Razão - Transportes Rodoviários Lda.'
                this.lineOperatorLogos.push('rodonorte');
                this.lineOperatorLogos.push('avlandim');
              break;
            default:
              this.complaint.operator = '';
          }
        }

        this.infoLoaded++;
      },
      error: er => {
        this.infoLoaded++;
        this.hasError = true;
      }
    });
  }

  goHome(){
    this.router.navigate(['/'])
  }
}
